<template>
    <div class="Alert" v-if="show">
        <div class="mask"></div>
        <div class="popContent">
            <!-- <div class="closeIcon hide" @click="close" v-if="closeBtn"></div> -->
            <div class="panels">
                <div v-if="title" class="title">{{title}}</div>
                <div class="content">
                    <div class="description" :style="{textAlign: align || 'left'}">
                        {{text}}
                    </div>
                    <div class="buttonArea">
                        <div class="btns red flex1" @click="submit">{{buttonText}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Index from './index.js';
    export default Index;
</script>

<style lang="less">
    @import './index.less';
</style>



// WEBPACK FOOTER //
// src/ui/alert/index.vue